import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { hourMinute } from '@showclix-projects/sc-intl/dist/dateTimeFormatters';
import { getNextAvailableEventTodayTime } from '../selectors/eventSeries';
import Translation from '@s/Translation';

class NextAvailableTimeSlot extends Component {

    render() {
        if (!this.props.nextAvailableEventTime || !this.props.isRecurring) {
            return null;
        }

        return (
            <span>
                <Translation interpolation={{hourMinute: hourMinute(this.props.locale, this.props.nextAvailableEventTime)}}>
                {'checkout__next_available_time_slot'}
                </Translation>
                </span>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        locale: state.intl.locale,
        nextAvailableEventTime: getNextAvailableEventTodayTime(state),
        isRecurring: Object.values(state.event.events)[0].event.isRecurring ? true : false,
    };
};

const mapDispatchToProps = dispatch => {
    return bindActionCreators({
    }, dispatch);
};

NextAvailableTimeSlot.propTypes = {
};

export default connect(mapStateToProps, mapDispatchToProps)(NextAvailableTimeSlot)
